import { CompanyContactType, FIELD_PATHS } from '@funnels/constants';

const mapFieldNamesForCompanyContactType = (index: number) => ({
  [CompanyContactType.Applicant]: {
    titlePath: FIELD_PATHS.APPLICANT_TITLE(index),
    firstNamePath: FIELD_PATHS.APPLICANT_FIRST_NAME(index),
    lastNamePath: FIELD_PATHS.APPLICANT_LAST_NAME(index),
    registeredAddressPath: FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_RESIDENTIAL(index),
    registeredAddressPathFormatted: FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_RESIDENTIAL_FORMATTED(index),
    tradingAddressPath: FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_RESIDENTIAL(index),
    tradingAddressPathFormatted: FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_RESIDENTIAL_FORMATTED(index),
    mailingAddressPath: FIELD_PATHS.APPLICANT_MAILING_ADDRESS(index),
    mailingAddressPathFormatted: FIELD_PATHS.APPLICANT_MAILING_ADDRESS_FORMATTED(index),
    contactNumberPath: FIELD_PATHS.APPLICANT_MOBILE(index),
    contactEmailPath: FIELD_PATHS.APPLICANT_EMAIL(index),
  },
  [CompanyContactType.NonApplicant]: {
    titlePath: FIELD_PATHS.RELATED_PARTY_TITLE(index),
    firstNamePath: FIELD_PATHS.RELATED_PARTY_FIRST_NAME(index),
    lastNamePath: FIELD_PATHS.RELATED_PARTY_LAST_NAME(index),
    registeredAddressPath: FIELD_PATHS.RELATED_PARTY_COMPANY_CONTACT_REGISTERED_ADDRESS(index),
    registeredAddressPathFormatted: FIELD_PATHS.RELATED_PARTY_COMPANY_CONTACT_REGISTERED_FORMATTED_ADDRESS(index),
    tradingAddressPath: FIELD_PATHS.RELATED_PARTY_COMPANY_CONTACT_TRADING_ADDRESS(index),
    tradingAddressPathFormatted: FIELD_PATHS.RELATED_PARTY_COMPANY_CONTACT_TRADING_FORMATTED_ADDRESS(index),
    mailingAddressPath: FIELD_PATHS.RELATED_PARTY_COMPANY_CONTACT_MAILING_ADDRESS(index),
    mailingAddressPathFormatted: FIELD_PATHS.RELATED_PARTY_COMPANY_CONTACT_MAILING_FORMATTED_ADDRESS(index),
    contactNumberPath: FIELD_PATHS.RELATED_PARTY_CONTACT_NUMBER(index),
    contactEmailPath: FIELD_PATHS.RELATED_PARTY_CONTACT_EMAIL(index),
  },
});

export default mapFieldNamesForCompanyContactType;
